import { faPlus } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { tss } from 'tss-react';

import ApiKeyList from 'components/desktop/User/ApiKey/ApiKeyList';
import OverlayContent from 'components/desktop/User/ApiKey/OverlayContent';
import * as UserState from 'components/desktop/User/User/State';
import { Handlers } from 'components/desktop/User/User/useState';
import CardTransparent from 'components/desktop/_general/Card/CardTransparent';
import Overlay from 'components/desktop/_general/Overlay/Overlay';

interface IProps {
	state: UserState.Type;
	handlers: Handlers;
}

const HandleApiKeys = (props: IProps) => {
	const { t } = useTranslation();
	const { classes } = useStyles();
	return (
		<CardTransparent
			title={t('_general:API_KEYS')}
			content={
				<>
					<Overlay
						displayOverlay={props.state.currentApiKeyId !== null}
						handleClose={() => props.handlers.clickCancel()}
					>
						<OverlayContent state={props.state} handlers={props.handlers} />
					</Overlay>
					<div className={classes.container}>
						<ApiKeyList state={props.state} handlers={props.handlers} />
						<button
							className="btn btn-primary btn-sm"
							onClick={props.handlers.addNewApiKey}
						>
							<FontAwesomeIcon icon={faPlus} className={classes.icon} />
							{t('_general:BTN_NEW_API_KEY')}
						</button>
					</div>
				</>
			}
		/>
	);
};

export default HandleApiKeys;

const useStyles = tss.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: '5px',
	},
	icon: {
		marginRight: '5px',
	},
});
